import React from 'react';

import { DatePickerProps } from '@lyearn/ui';
import dynamic from '@/utils/dynamic';

const DatePickerUI = dynamic(
  () =>
    import(
      /* webpackChunkName: "date-picker-ui" */
      './DatePickerUI'
    ),
);

const DatePicker = (props: DatePickerProps) => {
  return (
    <React.Suspense fallback={props.children || null}>
      <DatePickerUI {...props} />
    </React.Suspense>
  );
};

export default DatePicker;
